import React, { Component } from 'react';

import BackdropProgress from './core/components/BackdropProgress';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import ConfirmDialog from './core/components/ConfirmDialog';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper';
import SaveIcon from '@material-ui/icons/Save';
import Select from '@material-ui/core/Select';
import Skeleton from '@material-ui/lab/Skeleton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Title from './Title';
import { releaseService } from '_services';
import { withStyles } from '@material-ui/core/styles';

const useStyles = theme => ({
  seeMore: {
    marginTop: theme.spacing(3),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
    margin: theme.spacing(2),
    marginTop: theme.spacing(0),
  },
  fixedHeight: {
    height: 240,
  },
});

class ProdManifest extends Component {
  constructor() {
    super()
    this.state = {
      loading: false,
      confirmationDialog: false,
      prodManifestResponse: [],
      releaseResponse: [],
      // regressionVersion: '',

    }
    this.handleReleaseVersionChange = this.handleReleaseVersionChange.bind(this);
  }

  getReleases(){
    releaseService.getAllReleases().then(
      (data) => {
        this.setState({
          loading: false,
          regressionVersion: data[0],
          releaseResponse: data,
        })
      }
    )
  }
  
  
  getProdManifest(releaseVersion) {
    releaseService.getProdManifest(releaseVersion).then(
      (data) => {
        this.setState({
          loading: false,
          prodManifestResponse: data,
        });
      },
      (error) => {
        // TO-DO Add Error component
      },
    );
  }
  
  handleReleaseVersionChange = (e) => {
    let releaseVersion = e.target.value

    this.setState({
      regressionVersion: releaseVersion
    })
    this.getProdManifest(releaseVersion)
  }


  renderConfirmationDialog() {
    let prodManifestResponse = this.state.prodManifestResponse;
    return (<div>
      <Box textAlign='right'>
        <Button
          variant="contained"
          color="primary"
          size="small"
          align="left"
          startIcon={<SaveIcon />}
          // onClick={() => copy(JSON.stringify(prodManifestResponse, null, 2))}
        >
          Copy
        </Button>
      </Box>
      <pre>{JSON.stringify(prodManifestResponse, null, 2)}</pre>
      
    </div>);
  }

  handleClickOpen = () => {
    this.setState({ confirmationDialog: true });
  };

  setOpen = (state) => {
    this.setState({ confirmationDialog: state });
  };

  componentDidMount() {
    this.setState({ loading: true })
    
    this.getReleases()
    // this.setLastRelease()
    this.getProdManifest(this.state.regressionVersion)
  }

  render() {
    const { classes } = this.props;
    return (
      <React.Fragment>
        <Grid item xs={12}>
          <Paper className={classes.paper}>
            <Title>Production Manifest</Title>
            {this.state.loading && <BackdropProgress loading={this.state.loading} />}

            <FormControl className={classes.formControl}>
                <InputLabel id="demo-simple-select-label">Regression Branch</InputLabel>
                <Select labelId="r-branch-label" id="r-branch" value={this.state.regressionVersion} onChange={(e) => this.handleReleaseVersionChange(e)}>
                {this.state.releaseResponse.map((name, index) => (  
                     <MenuItem key={index} value={name}>{name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            <br></br>
            {this.state.loading ? (
              <Skeleton variant="rect" width="100%">
              </Skeleton>
            ) : (
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell>Repo</TableCell>
                      <TableCell>Artifact</TableCell>
                      <TableCell>Version</TableCell>
                      <TableCell>Commit SHA</TableCell>
                      <TableCell>Branch</TableCell>
                      <TableCell>Docker Image</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody >
                    {this.state.prodManifestResponse.map((pr, i) => (
                      <TableRow hover key={i}>
                        <TableCell>{pr.repo}</TableCell>
                        <TableCell>{pr.artifact}</TableCell>
                        <TableCell>{pr.version}</TableCell>
                        <TableCell>{pr.commitSha}</TableCell>
                        <TableCell>RB-{pr.repo}-{this.state.regressionVersion}</TableCell>
                        <TableCell>{pr.dockerImage}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              )}
            <div align="right" className={classes.seeMore}>
              <Button variant="contained" color="primary" onClick={this.handleClickOpen}>
                Generate JSON
            </Button>
              <ConfirmDialog
                title="Production Manifest JSON"
                open={this.state.confirmationDialog}
                setOpen={this.setOpen}
                onConfirm={this.updateReleaseArtifacts}
                variant="info"
              >

                {this.renderConfirmationDialog()}


              </ConfirmDialog>
            </div>
          </Paper>
        </Grid>
      </React.Fragment>
    )
  }
}

export default withStyles(useStyles)(ProdManifest)
